import Alpine from "alpinejs";

// First argument need to be a function
// Second argument is the timer
// Third argument is the delay (optional)

Alpine.magic("interval", () => {
    return function (...args) {
        const functionToCall = args[0];
        if (typeof functionToCall !== "function") {
            return functionToCall;
        }
        const timer = args[1];
        const delay = args[2] || 0;

        const loop = () => {
            setTimeout(() => {
                functionToCall.call(this);
                requestAnimationFrame(loop);
            }, timer);
        };

        setTimeout(() => {
            requestAnimationFrame(loop);
        }, delay);
    };
});
